import { FunctionComponent, PropsWithChildren, useMemo } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import styles from './styles.module.scss';
import { CademyTerms } from './CademyTerms';
import Button from '../../Button';
import { PublicEducator } from '@cademy-package/sdk-component-types';
import ReactHTML from '../../ReactHTML';

export type TermsDialogProps = PropsWithChildren<{
    educator?: PublicEducator;
    onAgree?: () => void;
}>;

export const TermsDialog: FunctionComponent<TermsDialogProps> = ({
    educator,
    onAgree,
    children,
}) => {
    const educatorTerms = useMemo(() => {
        if (!educator || !educator.tos) {
            return null;
        }

        return (
            <>
                <h2>{educator.name}&apos;s Terms of Service</h2>
                <ReactHTML html={educator.tos} />
            </>
        );
    }, [educator]);

    return (
        <Dialog.Root>
            <Dialog.Trigger asChild>{children}</Dialog.Trigger>
            <Dialog.Portal>
                <Dialog.Overlay className={styles.DialogOverlay} />
                <Dialog.Content className={styles.DialogContent}>
                    <Dialog.Title className={`${styles.DialogTitle}`}>
                        Terms of Service
                    </Dialog.Title>
                    <Dialog.Description>
                        Please read and agree to the terms of service before continuing.
                    </Dialog.Description>

                    <div className={styles.termsScroller}>
                        {educatorTerms}
                        <CademyTerms />
                        <h2>Dispute Resolution</h2>
                        <p>
                            At Cademy, we are committed to ensuring a positive and enriching
                            experience for all our users. We understand, however, that disputes may
                            occasionally arise, be it with an educator, a course, or any part of the
                            process associated with your experience on our platform. Should you find
                            yourself dissatisfied with any aspect of your experience, we encourage
                            you to bring your grievance to our attention. While Cademy is not
                            obligated to resolve disputes, we will endeavour to facilitate a
                            resolution between the parties involved, aiming to reach an amicable
                            agreement that respects the interests of all. It is important to note
                            that customers must raise any disputes within 30 days from the delivery
                            date of the course or workshop in question. This time frame allows us to
                            address and attempt to resolve any issues in a timely manner, ensuring
                            that the integrity of the platform is maintained for all stakeholders
                            involved.
                        </p>
                    </div>

                    <Dialog.Close asChild>
                        <Button preset="primary" onClick={onAgree}>
                            I agree
                        </Button>
                    </Dialog.Close>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
